import { createFileRoute } from '@tanstack/react-router'
import { TerminalConnectEmbedPage } from '@terminalConnect/testHarness/TerminalConnectEmbedPage'

export const Route = createFileRoute('/_auth/terminal-connect/embed')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TerminalConnectEmbedPage />
}
